/**
 * Floating progress card for a pay-stub import: file counter + bar. Shown
 * while importStubsInBatches (or a single-file upload) is running.
 * `progress` = { done, total, pct, current: [names] } or null to hide.
 */
import { Loader2 } from "lucide-react";

export const StubImportProgress = ({ progress, testId = "stub-import-progress" }) => {
  if (!progress) return null;
  const { done = 0, total = 0, pct = 0, current = [] } = progress;
  const finished = total > 0 && done >= total;
  return (
    <div data-testid={testId} role="status" aria-live="polite"
      className="fixed bottom-4 right-4 z-[170] w-[min(92vw,22rem)] rounded-xl border border-gray-200 bg-white p-4 shadow-2xl dark:border-white/15 dark:bg-[#0d0d0d]">
      <div className="flex items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-gray-900 dark:text-white">
          {!finished && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          {finished ? "Import finished" : "Importing pay stubs"}
        </p>
        <p className="font-mono text-xs tabular-nums text-gray-700 dark:text-white/75" data-testid={`${testId}-counter`}>
          {Math.min(done, total)} / {total} files
        </p>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-white/10">
        <div className="h-full rounded-full bg-[#1a3fd1] transition-[width] duration-300 ease-out"
          style={{ width: `${Math.max(2, Math.min(100, pct))}%` }} data-testid={`${testId}-bar`} />
      </div>
      <p className="mt-1.5 truncate font-mono text-[10px] text-gray-600 dark:text-white/55" data-testid={`${testId}-detail`}>
        {finished ? "Done — see the results" : `${pct}%${current.length ? ` · ${current[0]}${current.length > 1 ? ` +${current.length - 1}` : ""}` : ""}`}
      </p>
    </div>
  );
};
